import React from 'react';
import { glassTypes } from '../../../glassConsts';
import { useConfig } from '../../ConfigContext';

export function TypeSelector() {
  const { general, setGeneralState } = useConfig();

  return (
    <div>
      <label className="custom-label"></label>
      <div className="font-select">
        {glassTypes.map((f, i) => (
          <button
            className={` ${i === 0 ? 'rounded-l-lg' : ''} ${i === 4 ? 'rounded-r-lg' : ''} px-2 py-2 border border-gray-300 ${
              general.glassType === f.type ? 'selected-font' : ''
            }`}
            key={f.name}
            value={f.type}
            onClick={() => setGeneralState({ glassType: f.type })}
          >
            {f.name}
          </button>
        ))}
      </div>
    </div>
  );
}
